import { isNotEmpty } from '../../../common/utils/utils';
import { GeneralMutationErrorResultCreator, MissingMutationDataResultCreator, MutationErrorResultCreator, NonOkMutationResultCreator } from '../../graphql-result';
export default class Requester {
  constructor(broker) {
    this.broker = broker;
  }
  fetch(request) {
    return new Promise(async (resolve, reject) => {
      var _json$data, _mutationRes$errors;
      const response = await fetch(request);
      if (!response.ok) {
        return reject(new NonOkMutationResultCreator(response).makeMutationResult());
      }
      const json = await response.json();
      if (json.errors) {
        return reject(new GeneralMutationErrorResultCreator(json.errors).makeMutationResult());
      }
      const schemaResponse = json === null || json === void 0 ? void 0 : (_json$data = json.data) === null || _json$data === void 0 ? void 0 : _json$data.appRecommendations;
      const mutationRes = this.broker.extract(schemaResponse);

      // Error handling based on missing data
      if (!isNotEmpty(mutationRes)) {
        return reject(new MissingMutationDataResultCreator(response).makeMutationResult());
      }

      // Error handling based on Mutation Error
      if ((_mutationRes$errors = mutationRes.errors) !== null && _mutationRes$errors !== void 0 && _mutationRes$errors.length) {
        return reject(new MutationErrorResultCreator(mutationRes).makeMutationResult());
      }
      return resolve(this.broker.getSuccessResultCreator(response, mutationRes).makeMutationResult());
    });
  }
}